import { Component, OnInit, Input } from '@angular/core';
import { BankLinkingComponentData, FinancialInstitution, bankLogoExists, getBankLogo } from '../../bank-account/bank-account.model';
import { EnumHelper, BankAccountType } from 'common';
import { BankingService } from '../../bank-account/banking.service';

@Component({
    selector: 'ifp-bank-linking',
    templateUrl: './bank-linking.component.html',
    styleUrls: ['./bank-linking.component.scss'],
    standalone: false
})
export class BankLinkingComponent implements OnInit {

  @Input() bankLinkingData: BankLinkingComponentData;

  constructor(
    private bankingService: BankingService) {
    sessionStorage.setItem('relinkAccountViewed', JSON.stringify(true));
  }

  ngOnInit() {
    this.bankingService.integrationReminded(this.bankLinkingData.entity.id);
  }

  

  logoExists(_institutionId?: string, institutionName?: string) {
    return bankLogoExists(institutionName);
  }

  getLogo(_institutionId: string, institutionName?: string) {
    return getBankLogo(institutionName);

  }

  relink(financialInstitution: FinancialInstitution) {
    this.bankingService.relink(this.bankLinkingData.entity.id, financialInstitution, 'dashboard');
  }

  getBankAccountTypeName(type: string) {
    if (!type) return;
    return EnumHelper.getNameFromValue(BankAccountType, type);
  }
}
